// advancedSearchSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isAdvancedSearchLoading: null,
    isAdvancedSearchError: null,
    isAdvancedSearchActive: null,
    currentSearch: null,
    columnsType: null,
    messageErrorAdvancedSearch: null,
    savedFilters: null,  // ← AJOUTER ICI
    serverPagination: {
        page: 1,
        limit: 20,
        totalCount: 0,
        totalPages: 0,
        hasNextPage: false,
        hasPrevPage: false,
    },
    serverSorting: {
        sortField: 'displayName',
        sortOrder: 'asc',
    },
    isPageLoading: false,
}

const advancedSearchSlice = createSlice({
    name: 'advancedSearch',
    initialState,
    reducers: {
        fetchingAdvancedSearchStart: (state) => {
            state.isAdvancedSearchActive = true;
            state.isAdvancedSearchLoading = true;
            state.isAdvancedSearchError = false;
            state.messageErrorAdvancedSearch = null;
        },
        fetchingAdvancedSearchSuccess: (state, action) => {
            state.currentSearch = action.payload.data;
            state.serverPagination = {
                ...state.serverPagination,
                ...action.payload.pagination,
            };
            state.isAdvancedSearchLoading = false;
            state.isPageLoading = false;
        },
        fetchingAdvancedSearchFailure: (state, action) => {
            state.isAdvancedSearchActive = false;
            state.isAdvancedSearchLoading = false;
            state.isPageLoading = false;
            state.isAdvancedSearchError = true;
            state.messageErrorAdvancedSearch = action.payload;
        },
        fetchingAdvancedSearchReset: (state) => {
            state.isAdvancedSearchActive = false;
            state.isAdvancedSearchLoading = false;
            state.isPageLoading = false;
            state.currentSearch = null;
            state.messageErrorAdvancedSearch = null;
            state.savedFilters = null;
            state.serverPagination = {
                page: 1,
                limit: 20,
                totalCount: 0,
                totalPages: 0,
                hasNextPage: false,
                hasPrevPage: false,
            };
            state.serverSorting = {
                sortField: 'displayName',
                sortOrder: 'asc',
            };
        },
        setColumnsType: (state, action) => {
            state.columnsType = action.payload;
        },
        fetchingPageStart: (state) => {
            state.isPageLoading = true;
            state.isAdvancedSearchError = false;
        },
        setServerPage: (state, action) => {
            state.serverPagination.page = action.payload;
        },
        setServerLimit: (state, action) => {
            state.serverPagination.limit = action.payload;
            state.serverPagination.page = 1;
        },
        setServerSorting: (state, action) => {
            state.serverSorting = {
                sortField: action.payload.sortField,
                sortOrder: action.payload.sortOrder,
            };
            state.serverPagination.page = 1;
        },
        // ========== NOUVEAU REDUCER ==========
        setSavedFilters: (state, action) => {
            state.savedFilters = action.payload;
        },
        // =====================================
    }
});

export const {
    fetchingAdvancedSearchFailure, 
    fetchingAdvancedSearchStart, 
    fetchingAdvancedSearchSuccess, 
    fetchingAdvancedSearchReset, 
    setColumnsType,
    fetchingPageStart,
    setServerPage,
    setServerLimit,
    setServerSorting,
    setSavedFilters,  // ← EXPORTER
} = advancedSearchSlice.actions;

export default advancedSearchSlice.reducer;